// // components/OldBlogRedirect.js
// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const OldBlogRedirect = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     navigate("/blog/medical-billing-techniques", { replace: true });
//     navigate("/blog/healthcare-revenue-cycle-challenges", { replace: true });
//     navigate("/blog/revenue-cycle-management-tips", { replace: true });
//     navigate("/blog/outsourcing-medical-billing-benefits", { replace: true });
//     navigate("/blog/comparing_healthcare_revenue_cycle_management_vs_health_informatics", { replace: true });
//     navigate("/blog/rcm-vs-health-informatics", { replace: true });
//     navigate("/blog/de_identified_health_information", { replace: true });
//     navigate("/blog/patient-data-protection", { replace: true });
//     navigate("/blog/claims-processing-technology", { replace: true });
//     navigate("/blog/prevent-medical-billing-rejections", { replace: true });
//     navigate("/blog/healthcare-revenue-cycle-management", { replace: true });
//     navigate("/blog/medical-billing-to-boost-revenue", { replace: true });
//     navigate("/blog/medical-billing-trends-2023-24", { replace: true });
//     navigate("/blog/best-medical-billing-company", { replace: true });
//     navigate("/blog/increase-healthcare-practice-revenue", { replace: true });
//     navigate("/blog/patient-engagement-techniques", { replace: true });
//     navigate("/blog/electronic-health-records-basics", { replace: true });
//     navigate("/blog/what-billing-means-for-patients", { replace: true });
//     navigate("/blog/medical-billing-vs-credentialing", { replace: true });



//   }, [navigate]);

//   return null; // don't render anything
// };

// export default OldBlogRedirect;
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const OldBlogRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Check the current path and navigate to the corresponding new URL
    switch (path) {
      case "/blog/whats_the_difference_between_medical_billing_and_credentialing":
        navigate("/blog/medical-billing-vs-credentialing", { replace: true });
        break;
      case "/blog/choosing_to_outsource_your_medical_billing_is_a_smart_decision":
        navigate("/blog/outsourcing-medical-billing-benefits", { replace: true });
        break;
      case "/blog/maximize_revenue_and_minimize_hassles_with_acerhealth_experts_medical_billing_services":
        navigate("/blog/medical-billing-to-boost-revenue", { replace: true });
        break;
      case "/blog/unveiling_the_core_concepts_of_electronic_health_records_EHRs":
        navigate("/blog/electronic-health-records-basics", { replace: true });
        break;
      case "/blog/best_practices_for_improving_revenue_cycle_management":
        navigate("/blog/revenue-cycle-management-tips", { replace: true });
        break;
      case "/blog/how_to_accelerate_claims_processing_technology":
        navigate("/blog/claims-processing-technology", { replace: true });
        break;
      case "/blog/obtain_billing_services_from_the_best_medical_billing_company":
        navigate("/blog/best-medical-billing-company", { replace: true });
        break;
      case "/blog/Techniques_to_Increase_Patient_Engagement":
        navigate("/blog/patient-engagement-techniques", { replace: true });
        break;
      case "/blog/medical_billing_trends_to_watch_in_2023_24":
        navigate("/blog/medical-billing-trends-2023-24", { replace: true });
        break;
      case "/blog/comparing_healthcare_revenue_cycle_management_vs_health_informatics":
        navigate("/blog/rcm-vs-health-informatics", { replace: true });
        break;
      case "/blog/management_of_the_healthcare_revenue_cycle":
        navigate("/blog/healthcare-revenue-cycle-management", { replace: true });
        break;
      case "/blog/details_about_patients_is_protected_by_acerhealth":
        navigate("/blog/patient-data-protection", { replace: true });
        break;
      case "/blog/de_identified_health_information":
        navigate("/blog/increase-healthcare-revenue", { replace: true });
        break;
      case "/blog/potentially_how_can_we_increase_your_revenues":
        navigate("/blog/increase-healthcare-practice-revenue", { replace: true });
        break;
      case "/Best_Practices_for_Improving_Revenue_Cycle_Management_AcerHealth":
        navigate("/blog/increase-healthcare-practice-revenue", { replace: true });
        break;
      case "/credentialing":
        navigate("/services/medical-billing-and-credentialing", { replace: true });
        break;

      case "testimonials.php":
        navigate("testimonials", { replace: true });
        break;

      case "/credentialing-services.php":
        navigate("/services/medical-billing-and-credentialing", { replace: true });
        break;

      case "/blogs/de_identified_health_information":
        navigate("/blog/increase-healthcare-revenue", { replace: true });
        break;

      case "/Eligibility":
        navigate("/technologies/patient-eligibility-verification", { replace: true });
        break;

      case "/wp_site/medical-billing-services-healthcare-services/":
        navigate("/services/medical-billing-and-credentialing", { replace: true });
        break;

      case "/covidrelief.php":
        navigate("/acerhealth.com/", { replace: true });
        break;

      case "/eligibility-verification":
        navigate("/technologies/patient-eligibility-verification", { replace: true });
        break;

      case "/patient-out-of-pocket-calculator":
        navigate("/technologies/patient-balance-estimator", { replace: true });
        break;

      case "/OldWebsite/contactus.php":
        navigate("/contact-us", { replace: true });
        break;

      case "/wp_site/medical-coding/":
        navigate("/services/medical-billing-and-credentialing", { replace: true });
        break;

      case "/free-consultation.php":
        navigate("/contact-us", { replace: true });
        break;

      case "/wp_site/billing-services/":
        navigate("blog/outsourcing-medical-billing-benefits", { replace: true });
        break;

      case "/patient-balance-estimator.php":
        navigate("/technologies/patient-balance-estimator", { replace: true });
        break;

      case "/acerhealth.com/join-acerhealth.php":
        navigate("/contact-us", { replace: true });
        break;

      case "/blogs/comparing_healthcare_revenue_cycle_management_vs_health_informatics":
        navigate("blog/rcm-vs-health-informatics", { replace: true });
        break;


      case "/blogs/unveiling_the_core_concepts_of_electronic_health_records_EHRs":
        navigate("/blog/electronic-health-records-basics", { replace: true });
        break;

      case "/blog/medical-billing-guide":
        navigate("/blog/Ultimate-Guide-to-Medical-Billing", { replace: true });
        break;

      case "/blogs/whats_the_difference_between_medical_billing_and_credentialing":
        navigate("/blog/medical-billing-vs-credentialing", { replace: true });
        break;

      case "/blog/AcerHealth_medical_billing_techniques":
        navigate("/blog/medical-billing-techniques", { replace: true });
        break;
        

      case "/wp_site/electronic-health-records/":
        navigate("/blog/electronic-health-records-basics", { replace: true });
        break;

      case "/blogs/medical_billing_trends_to_watch_in_2023_24":
        navigate("/blog/medical-billing-trends-2023-24", { replace: true });
        break;

      case "/blogs/Challenges_in_managing_the_healthcare_revenue_cycle":
        navigate("/blog/revenue-cycle-management-tips", { replace: true });
        break;

      case "/blog/medical-billing-trends-2025Top":
        navigate("/blog/medical-billing-trends-2025", { replace: true });
        break;

      case "/blog/medical-billing-services-for-small-practicesMedical":
        navigate("/blog/medical-billing-services-for-small-practices", { replace: true });
        break;

      case "/blogs/potentially_how_can_we_increase_your_revenues":
        navigate("/blog/increase-healthcare-practice-revenue", { replace: true });
        break;

      case "/blogs/maximize_revenue_and_minimize_hassles_with_acerhealth_experts_medical_billing_services":
        navigate("/blog/medical-billing-to-boost-revenue", { replace: true });
        break;

      case "/blog/How_to_Prevent_Medical_Billing_Rejections":
        navigate("/blog/prevent-medical-billing-rejections", { replace: true });
        break;

      case "/blog/patient-engagement-techniques":
        navigate("/blogs/techniques_to_increase_patient_engagement", { replace: true });
        break;

      case "/blog/10-questions-before-outsourcing-medical-billing":
        navigate("/blog/outsourcing-medical-billing-questions", { replace: true });
        break;

      case "/blogs/how_to_prevent_medical_billing_rejections":
        navigate("/blog/prevent-medical-billing-rejections", { replace: true });
        break;

      case "/blogs/details_about_patients_is_protected_by_acerhealth":
        navigate("/blog/patient-data-protection", { replace: true });
        break;
        
      case "/blogs/details_about_patients_is_protected_by_acerhealth":
        navigate("/blog/healthcare-revenue-cycle-challenges", { replace: true });
        break;

 case "/wp_site/medical-billing/":
        navigate("/services/medical-billing-services", { replace: true });
        break;

      default:
        break;
    }
  }, [navigate, location]);

  return null; // don't render anything
};

export default OldBlogRedirect;
